import { render, staticRenderFns } from "./settlement-actions.vue?vue&type=template&id=1cd361e4"
import script from "./settlement-actions.vue?vue&type=script&lang=js"
export * from "./settlement-actions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports